module.exports = __webpack_public_path__ + "static/media/15UN-Habitat3.cef088c1.jpg";